import { URL, FirebaseKey } from "./common";

export enum FileType {
  Image = "Image",
  Audio = "Audio",
}

export interface Story {
  humanName: string;
  fileName: string;
  url: URL;
  id: FirebaseKey;
  eventId: FirebaseKey;
  index?: number;
  type?: FileType;
}
